import React from 'react';

import GradeOutlinedIcon from '@mui/icons-material/GradeOutlined';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const RemoveFavoriteActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <GradeOutlinedIcon />
    </BaseActionButton>
  );
};

export default RemoveFavoriteActionButton;
